"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconQuestion = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconQuestion = function SvgIconQuestion(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12A6 6 0 116 0a6 6 0 010 12zm-.75-5.933v.308a.75.75 0 001.444.283 2.625 2.625 0 10-2.55-4.389 2.578 2.578 0 00-.769 1.864.753.753 0 001.507-.016 1.073 1.073 0 01.327-.783c.21-.21.496-.328.793-.328a1.119 1.119 0 010 2.237.753.753 0 00-.752.824zM6 10.5a1.126 1.126 0 100-2.251A1.126 1.126 0 006 10.5z",
    fill: "currentColor"
  }));
};

exports.SvgIconQuestion = SvgIconQuestion;